import { Box } from "@mui/material";

export const PROGRESS_TOOLTIP_SLOT_PROPS = {
  tooltip: {
    sx: {
      bgcolor: '#063236',
      color: '#fff',
      fontSize: '13px',
      fontWeight: 600,
      borderRadius: '20px',
      px: 2,
      py: 1,
    },
  },
  arrow: {
    sx: { color: '#063236' },
  },
};

export const CustomProgressBar = ({
  value = 0,
  bgColor = "#00D175",
  baseBgColor = "#96ECE0",
  borderRadius = "10px",
  labelColor = "#063236",
  labelSize = "14px",
  paddingY = "0px",
}) => {
  const filled = Math.min(Math.max(value, 0), 100);

  const labelSx = {
    display: "flex",
    alignItems: "center",
    paddingLeft: "12px",
    color: labelColor,
    fontSize: labelSize,
    fontWeight: "bold",
    whiteSpace: "nowrap",
  };

  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        alignItems: "stretch",
        borderRadius,
        overflow: "hidden",
        backgroundColor: baseBgColor,
        minHeight: `calc(${paddingY} * 2)`,
      }}
    >
      {filled > 0 ? (
        <Box
          sx={{
            ...labelSx,
            width: `${filled}%`,
            minWidth: "fit-content",
            backgroundColor: bgColor,
            justifyContent: "flex-start",
            paddingRight: "12px",
            flexShrink: 0,
            boxSizing: "border-box",
          }}
        >
          {`${value}%`}
        </Box>
      ) : (
        <Box sx={labelSx}>
          {`${value}%`}
        </Box>
      )}
    </Box>
  );
};
